export function objectToFormData(
  object: Record<string, any>,
  formData = new FormData(),
  parentKey = '',
): FormData {
  for (const key in object) {
    if (!Object.prototype.hasOwnProperty.call(object, key)) continue

    const value = object[key]
    const formKey = parentKey ? `${parentKey}.${key}` : key

    if (value == undefined) continue

    if (value instanceof File) {
      formData.append(formKey, value)
    } else if (value instanceof Object && !(value instanceof Date)) {
      objectToFormData(value, formData, formKey)
    } else {
      formData.append(formKey, value.toString())
    }
  }
  return formData
}
